module.exports = __webpack_public_path__ + "images/3bd08efc33e8774b055e35a855f9c60a.png";